(function () {
    var OPEN_CLASS = 'cl-edit-open';
    var openedFor = null;   // ảnh đã mở modal lần gần nhất, tránh mở lại khi Vue vẽ lại
    var origin = null;      // {parent, next} để trả khung canvas về đúng chỗ khi đóng
    var controlsOrigin = null;   // chỗ cũ của hàng nút chỉnh
    var sizeSnapshot = null;     // kích thước canvas trước khi vào modal
    var srcBeforeChange = null;  // ảnh đang hiển thị lúc khách bấm chọn ảnh khác
    var mobileUploading = false; // 05/11: mobile vừa chọn ảnh -> phủ thanh % lên khung của app

    function uploadBox() {
      return document.querySelector('#cl_optionsapp .customily-file-input.customily-file-with-thumbnail');
    }

    function uploadedSrc() {
      var box = uploadBox();
      if (!box) return null;
      if (box.querySelector('.spinner-border')) return null;
      var replaceBtn = box.querySelector('.customily-download-button');
      if (replaceBtn && (replaceBtn.disabled || replaceBtn.classList.contains('disabled'))) return null;
      var thumb = box.querySelector('.customily-file-input-thumbnail img');
      return thumb && thumb.src ? thumb.src : null;
    }

    function canvasBox() {
      return document.querySelector('.cl-canvas-container');
    }

    /* Bố cục mobile của app khác hẳn desktop:
         desktop -> canvas nằm sẵn trong .cl-canvas-container, đè lên ảnh sản phẩm
         mobile  -> KHÔNG có lớp đó; canvas chỉ tồn tại bên trong
                    .customily-modal-preview-only, và modal đó display:none
       Nên trên mobile không có gì để nhấc vào modal của mình — mở ra sẽ đứng
       mãi ở trạng thái đang tải. Ở đó dùng thẳng modal xem trước của app
       (đã được dựng lại giao diện ở snippet customily-preview-modal). */
    function isMobileLayout() {
      return !canvasBox() && !!document.querySelector('.customily-modal-preview-only');
    }

    /* Mở thẳng modal xem trước của app bằng cách bật display.
       KHÔNG bấm hộ nút "Preview your Personalization": nút đó bắt buộc mọi ô
       phải điền xong, mà lúc vừa chọn ảnh thì tên/màu còn trống nên chỉ hiện
       báo lỗi. Bật display thì canvas vẫn vẽ đúng ảnh vừa tải (đã kiểm trên
       khung 390px: canvas 330x330, có nét, đủ 7 nút chỉnh). */
    function closeAppPreview(m) {
      /* Đóng bằng cách tắt display, KHÔNG bấm nút X của app: mình mở nó bằng
         display nên trạng thái bên trong app vẫn là "đang đóng"; bấm X thì app
         không làm gì và modal đứng nguyên (đã đo: bấm xong display vẫn flex). */
      m.style.display = 'none';
      m.removeAttribute('data-cl-edit-mode');
      var ov = m.querySelector('.cl-edit-loading--mobile');
      if (ov) ov.remove();
      document.body.style.overflow = '';
    }

    /* Đổi nút chân modal cho đúng ngữ cảnh.
       Modal này vốn là "Preview your Personalization" nên chân thẻ là
       Keep editing / Add to cart. Nhưng ở mobile mình dùng nó ngay sau khi
       khách tải ảnh, tức đang CHỈNH ảnh chứ chưa xem lại lần cuối — hai nút
       kia sai mục đích. Thay bằng Replace photo / Done cho khớp modal chỉnh
       ảnh bên desktop. */
    function editButtons(m) {
      var main = m.querySelector('.main');
      if (!main) return;
      var foot = m.querySelector('.cl-preview-foot');
      /* Tự dựng chân nếu chưa có: ở chế độ chỉnh, snippet preview cố ý không
         dựng chân (để khỏi tạo nhầm Keep editing / Add to cart), nên nếu ở đây
         cũng bỏ qua thì modal không có nút nào. */
      if (!foot) {
        foot = el('div', 'cl-preview-foot');
        main.appendChild(foot);
      }
      /* Dựng lại theo TỪNG LẦN MỞ, không đánh dấu một lần rồi thôi: cùng một
         modal phục vụ hai luồng khác nhau —
           mở từ upload  -> đang chỉnh ảnh -> Replace photo / Done
           mở từ nút Preview -> xem lại lần cuối -> Keep editing / Add to cart
         Ghi đè vĩnh viễn thì bấm Preview cũng ra nút của chế độ chỉnh. */
      if (foot.dataset.clMode === 'edit') return;
      foot.dataset.clMode = 'edit';
      foot.innerHTML = '';

      var replaceBtn = el('button', 'cl-preview-btn cl-preview-btn--secondary', 'Replace photo');
      replaceBtn.type = 'button';
      replaceBtn.addEventListener('click', function () {
        var real = document.querySelector('#cl_optionsapp .customily-file-with-thumbnail .customily-download-button');
        closeAppPreview(m);
        if (real) setTimeout(function () { real.click(); }, 200);
      });

      var doneBtn = el('button', 'cl-preview-btn cl-preview-btn--primary', 'Done');
      doneBtn.type = 'button';
      doneBtn.addEventListener('click', function () { closeAppPreview(m); });

      foot.appendChild(replaceBtn);
      foot.appendChild(doneBtn);
    }

    function openAppPreview() {
      var m = document.querySelector('.customily-modal-preview-only');
      if (!m) return;
      m.setAttribute('data-cl-edit-mode', '1');
      m.style.display = 'flex';
      document.body.style.overflow = 'hidden';

      /* 05/11/2026: trên mobile khung của app mở ngay lúc chọn ảnh, nhưng ảnh còn
         phải tải lên + xử lý ~20–30s; suốt lúc đó khách chỉ thấy ảnh mẫu, không
         biết đang chờ. Phủ đúng thanh % của bản desktop lên vùng ảnh + nút chỉnh
         (chừa hàng Replace photo / Done). check() gỡ nó khi ảnh xong. */
      if (mobileUploading) {
        mobileUploading = false;
        var wrap = m.querySelector('.canvas-wrapper');
        var old = m.querySelector('.cl-edit-loading--mobile');
        if (old) old.remove();
        if (wrap) {
          var ov = buildLoading();
          ov.classList.add('cl-edit-loading--mobile');
          wrap.appendChild(ov);
        }
      }

      // Nút X của app cũng phải đóng được ở chế độ này.
      var x = m.querySelector('.customily-close-button');
      if (x && !x.dataset.clWired) {
        x.dataset.clWired = '1';
        x.addEventListener('click', function () {
          if (m.getAttribute('data-cl-edit-mode')) closeAppPreview(m);
        }, true);
      }

      // Chờ app vẽ xong canvas rồi mới gắn nhãn và đổi nút.
      [700, 2000].forEach(function (t) {
        setTimeout(function () { labelControls(m); editButtons(m); }, t);
      });
    }

    function layerEl() {
      return document.querySelector('.cl-edit-layer');
    }

    function el(tag, className, text) {
      var node = document.createElement(tag);
      if (className) node.className = className;
      if (text) node.textContent = text;
      return node;
    }

    function closeModal() {
      document.documentElement.classList.remove(OPEN_CLASS);
      var box = canvasBox();
      if (box && origin && origin.parent) {
        // Trả về đúng vị trí cũ trong DOM, kể cả thứ tự anh em.
        if (origin.next && origin.next.parentNode === origin.parent) {
          origin.parent.insertBefore(box, origin.next);
        } else {
          origin.parent.appendChild(box);
        }
      }
      /* Trả hàng nút về trong khung canvas. Bắt buộc: app đo chiều cao của
         '.canvas-wrapper .customily-mobile-controls' để tính kích thước canvas —
         để nó ở ngoài thì lần tính sau app không thấy, canvas sẽ sai cỡ. */
      var controls = document.querySelector('.customily-mobile-controls');
      if (controls && controlsOrigin && controlsOrigin.parent) {
        if (controlsOrigin.next && controlsOrigin.next.parentNode === controlsOrigin.parent) {
          controlsOrigin.parent.insertBefore(controls, controlsOrigin.next);
        } else {
          controlsOrigin.parent.appendChild(controls);
        }
      }
      controlsOrigin = null;
      origin = null;

      // Trả kích thước canvas về đúng như trước khi mở modal.
      if (sizeSnapshot) {
        sizeSnapshot.forEach(function (r) {
          if (r.css) r.el.setAttribute('style', r.css);
          else r.el.removeAttribute('style');
        });
        sizeSnapshot = null;
      }

      // Xoá zoom SAU cùng: bước khôi phục ở trên ghi đè cả thuộc tính style.
      var boxNow = canvasBox();
      if (boxNow) boxNow.style.zoom = '';

      var layer = layerEl();
      if (layer) layer.remove();
      document.body.style.overflow = '';

      window.dispatchEvent(new Event('resize'));
    }

    /* Đưa canvas thật vào modal, bỏ khối đang tải. Gọi được nhiều lần: lần sau
       thấy canvas đã nằm trong modal thì thôi. */
    function mountCanvas() {
      var layer = layerEl();
      var card = layer && layer.querySelector('.cl-edit-card');
      var box = canvasBox();
      if (!card || !box) return;
      if (box.parentNode === card) return;

      var loading = card.querySelector('.cl-edit-loading');
      var hint = card.querySelector('.cl-edit-hint');

      /* Chụp lại kích thước canvas ở ngoài TRƯỚC khi chuyển vào modal.
         App đo bề ngang khối chứa một lần rồi giữ mãi; modal hẹp hơn ô ảnh
         (do còn phải vừa chiều cao màn hình) nên đóng modal xong ảnh sẽ bé
         lại. Trả lại đúng kích thước cũ là xong. */
      sizeSnapshot = [box].concat([].slice.call(box.querySelectorAll('*')))
        .map(function (el) {
          /* Bỏ zoom khỏi bản chụp. App dựng lại khung canvas nên mountCanvas có
             thể chạy vòng hai và chụp phải trạng thái ĐÃ zoom của lần trước —
             khôi phục nguyên xi thì zoom sống sót ra ngoài modal và ảnh bé lại
             (đo được style còn "zoom: 0.714" sau khi đóng). */
          var css = (el.getAttribute('style') || '').replace(/(^|;)\s*zoom\s*:[^;]*;?/gi, '$1');
          return { el: el, css: css };
        });

      origin = { parent: box.parentNode, next: box.nextSibling };
      card.insertBefore(box, hint);

      /* Tách hàng nút chỉnh ra khỏi khung canvas.
         Nút nằm trong khung, mà khung là phần được phép co và cuộn khi cửa sổ
         thấp — để nguyên thì cửa sổ 800px là hàng nút bị cuộn khuất, đúng thứ
         khách cần bấm nhất lại biến mất. Đưa ra ngoài thì nó luôn hiện.
         Chuyển node không mất listener; đóng modal sẽ trả về chỗ cũ. */
      var controls = box.querySelector('.customily-mobile-controls');
      if (controls) {
        controlsOrigin = { parent: controls.parentNode, next: controls.nextSibling };
        // Ép thứ tự dứt khoát: canvas TRƯỚC, hàng nút SAU. Chỉ chèn tuần tự thì
        // đo ra hàng nút nằm trên canvas, ngược với dòng chữ "buttons below".
        card.insertBefore(controls, hint);
        card.insertBefore(box, controls);
      }

      labelControls(card);
      fitCanvas(card, box);
      if (loading) loading.remove();
      progStop();
      layer.classList.remove('cl-edit-layer--loading');
    }

    /* Thu nhỏ HIỂN THỊ canvas cho vừa chiều cao màn hình, giữ nguyên bitmap.

       Dùng `zoom` chứ không phải `transform: scale`: zoom đổi cả kích thước
       chiếm chỗ trong bố cục nên các phần dưới tự dồn lên, còn transform thì
       phần tử vẫn chiếm chỗ như cũ và để lại khoảng trống.

       Vì sao không lo lệch kéo thả: canvas do fabric.js dựng (thấy hai lớp
       .lower-canvas / .upper-canvas), mà fabric tính toạ độ chuột qua
       getBoundingClientRect — hàm này trả về kích thước SAU khi zoom, nên
       phép quy đổi vẫn đúng. */
    function fitCanvas(card, box) {
      box.style.zoom = '';
      var chrome = 0;
      [].slice.call(card.children).forEach(function (el) {
        if (el !== box) chrome += el.getBoundingClientRect().height;
      });
      var room = window.innerHeight - 24 - chrome - 16;
      /* Lấy scrollHeight, KHÔNG lấy getBoundingClientRect: khung canvas là flex
         item co được và có overflow, nên chiều cao nhìn thấy đã bị cắt sẵn.
         Đo theo chiều cao nhìn thấy thì tỉ lệ luôn ra ~0.98 — zoom gần như
         không làm gì và ảnh vẫn bị cắt đáy. */
      var need = box.scrollHeight;
      if (need > room && room > 0) {
        box.style.zoom = Math.max(0.4, room / need).toFixed(3);
      }
    }

    /* Gắn nhãn cho 7 nút chỉnh.
       App chỉ vẽ icon trần, không chữ, không aria-label — người mua phải đoán.

       Gán theo THỨ TỰ DOM, không theo toạ độ. Hai lần trước mình gán theo vị
       trí và sai cả hai:
         - theo X: desktop xếp NGƯỢC (item[0] nằm ngoài cùng bên phải, x=871)
         - theo dòng rồi X: mobile xuống hai dòng, dòng trên là 4 mũi tên còn
           dòng dưới mới là zoom/xoay, nên nhãn lệch tiếp
       Thứ tự DOM thì giống nhau ở mọi bố cục. Đối chiếu bằng đường vẽ icon:
         idx0 mũi tên lên · idx1 xuống · idx2 trái · idx3 phải
         idx4 xoay (đường dài nhất) · idx5 phóng to · idx6 thu nhỏ */
    var CONTROL_LABELS = ['Move up', 'Move down', 'Move left', 'Move right',
                          'Rotate', 'Zoom in', 'Zoom out'];

    function labelControls(root) {
      var items = [].slice.call(root.querySelectorAll('.customily-mobile-controls-item'));
      if (items.length !== CONTROL_LABELS.length) return;
      items.forEach(function (item, i) {
        var text = CONTROL_LABELS[i];
        item.setAttribute('role', 'button');
        item.setAttribute('tabindex', '0');
        item.setAttribute('aria-label', text);
        item.setAttribute('title', text);
        var old = item.querySelector('.cl-ctrl-label');
        if (old) old.textContent = text;
        else item.appendChild(el('span', 'cl-ctrl-label', text));
      });
    }

    /* ---- Tiến độ % lúc đang tải ảnh ----
       Luồng của Customily khi khách chọn ảnh (đo 05/11, ảnh 720KB):
         ~0–1,1s  app tự đọc/thu nhỏ ảnh trong trình duyệt  -> không có số
         ~1,3–3s  XHR PUT lên customily.s3…/js-lib-temp-images -> CÓ % thật
         ~4–6,5s  POST app.customily.com/…/image/proc (xử lý) -> không có số
       Đoạn upload lấy đúng % của trình duyệt (15→75). Hai đoạn chờ còn lại
       cho số bò chậm dần tới một mức trần (15 / 97) để khách thấy vẫn đang
       chạy mà không bao giờ báo 100% khi ảnh chưa xong. Chỉ chạm 100 khi
       canvas thật đã gắn vào modal. */
    var prog = { shown: 0, target: 0, cap: 15, stage: 'prep', timer: null, sawBusy: false };
    var STAGE_TEXT = {
      prep: 'Preparing your photo…',
      upload: 'Uploading your photo…',
      process: 'Processing your photo…'
    };
    /* Tốc độ bò của từng đoạn chờ (mỗi 100ms tiến thêm x% quãng còn lại).
       Đoạn xử lý cho chậm: user thấy số đứng ở 95% ~10s (05/11) — trần 97 và
       bò chậm thì số vẫn nhích trong ~15s đầu thay vì đứng im. */
    var CREEP = { prep: 0.04, upload: 0.04, process: 0.012 };

    function progStart() {
      prog.shown = 0;
      prog.target = 0;
      prog.cap = 15;
      prog.stage = 'prep';
      prog.sawBusy = false;
      prog.startAt = Date.now();
      prog.putSeen = false;
      prog.procDone = 0;
      if (!prog.timer) prog.timer = setInterval(progTick, 100);
      progRender();
    }

    function progStop() {
      if (prog.timer) clearInterval(prog.timer);
      prog.timer = null;
    }

    function progTick() {
      // Đoạn chờ: tiến dần về mức trần, càng gần càng chậm.
      if (prog.target < prog.cap) {
        prog.target += Math.max(0.03, (prog.cap - prog.target) * (CREEP[prog.stage] || 0.03));
      }
      // Số hiển thị đuổi theo đích cho mượt, không nhảy cóc.
      if (prog.shown < prog.target) prog.shown += Math.max(0.3, (prog.target - prog.shown) * 0.25);
      if (prog.shown > prog.target) prog.shown = prog.target;
      progRender();
      if (!document.querySelector('.cl-edit-loading')) { progStop(); return; }
      mobileDoneCheck();
    }

    /* Mobile: spinner của app tắt sau ~0,2s dù ảnh còn đang tải lên + xử lý
       (đo 05/11 trên WebKit iPhone: tắt 0,2s, xử lý xong ~17–20s), nên KHÔNG
       dựa vào spinner. Gỡ lớp phủ khi request xử lý ảnh trả về (+1,2s cho app
       vẽ ảnh mới). Không thấy upload nào sau 20s mà app cũng không bận thì coi
       như app dùng lại ảnh cũ, gỡ luôn cho khỏi treo. */
    function mobileDoneCheck() {
      var ov = document.querySelector('.cl-edit-loading--mobile');
      if (!ov || prog.stage === 'fail') return;
      var now = Date.now();
      var busy = !!document.querySelector('#cl_optionsapp .spinner-border');
      var done = (prog.procDone && now - prog.procDone > 1200) ||
                 (!prog.putSeen && !busy && now - prog.startAt > 20000);
      if (!done) return;
      prog.shown = 100;
      progRender();
      progStop();
      setTimeout(function () { if (ov.parentNode) ov.remove(); }, 250);
    }

    function progRender() {
      var box = document.querySelector('.cl-edit-loading');
      if (!box || prog.stage === 'fail') return;
      var pct = Math.min(99, Math.floor(prog.shown));
      var num = box.querySelector('.cl-edit-pct');
      var bar = box.querySelector('.cl-edit-bar-fill');
      var text = box.querySelector('.cl-edit-loading-text');
      if (num) num.textContent = pct + '%';
      if (bar) bar.style.width = pct + '%';
      if (text) text.textContent = STAGE_TEXT[prog.stage];
      box.setAttribute('aria-valuenow', String(pct));
    }

    /* Customily báo lỗi upload bằng một dòng đỏ ở ô upload — nằm SAU modal nên
       khách không thấy, còn modal thì đứng mãi ở 95%. Đo 05/11: ảnh lỗi khi
       app tải ảnh đã xử lý về mất 30s rồi bỏ.
       Dòng lỗi CŨ còn nằm đó ~1s sau khi chọn ảnh mới, nên chỉ tính là lỗi khi
       app đã bắt đầu xử lý ảnh mới (sawBusy) rồi dòng lỗi mới hiện ra. */
    function uploadError() {
      var list = document.querySelectorAll('#cl_optionsapp .cl-error-message');
      for (var i = 0; i < list.length; i++) {
        if (/upload/i.test(list[i].textContent || '') && list[i].offsetParent) return true;
      }
      return false;
    }

    function progFail() {
      progStop();
      prog.stage = 'fail';
      var box = document.querySelector('.cl-edit-loading');
      if (!box) return;
      box.classList.add('cl-edit-loading--error');
      box.setAttribute('role', 'alert');
      box.removeAttribute('aria-valuenow');
      var text = box.querySelector('.cl-edit-loading-text');
      if (text) text.textContent = 'Upload failed. Please replace the photo and try again.';
    }

    /* Tối giản theo ý user (05/11): 1 thanh mảnh + số % nhỏ cùng hàng,
       1 dòng trạng thái màu xám. Không vòng, không icon, không chữ phụ. */
    function buildLoading() {
      var loading = el('div', 'cl-edit-loading');
      loading.setAttribute('role', 'progressbar');
      loading.setAttribute('aria-valuemin', '0');
      loading.setAttribute('aria-valuemax', '100');
      loading.setAttribute('aria-label', 'Photo upload progress');
      var row = el('div', 'cl-edit-progress');
      var bar = el('span', 'cl-edit-bar');
      bar.appendChild(el('span', 'cl-edit-bar-fill'));
      row.appendChild(bar);
      row.appendChild(el('span', 'cl-edit-pct', '0%'));
      loading.appendChild(row);
      loading.appendChild(el('p', 'cl-edit-loading-text', STAGE_TEXT.prep));
      return loading;
    }

    /* Nghe XHR của app. Chỉ gắn listener, không đổi gì trong request. */
    (function hookXhr() {
      var X = window.XMLHttpRequest;
      if (!X || X.prototype.__clEditHooked) return;
      X.prototype.__clEditHooked = true;
      var open = X.prototype.open;
      var send = X.prototype.send;
      X.prototype.open = function (method, url) {
        this.__clEditUrl = String(url || '');
        return open.apply(this, arguments);
      };
      X.prototype.send = function () {
        var url = this.__clEditUrl || '';
        if (/js-lib-temp-images/.test(url) && this.upload) {
          prog.sawBusy = true;
          prog.putSeen = true;
          prog.stage = 'upload';
          this.upload.addEventListener('progress', function (e) {
            if (!e.lengthComputable || !e.total) return;
            prog.target = Math.max(prog.target, 15 + 60 * (e.loaded / e.total));
            prog.cap = prog.target;
          });
          this.addEventListener('loadend', function () {
            prog.stage = 'process';
            prog.target = Math.max(prog.target, 75);
            prog.cap = 97;
          });
        } else if (/\/image\/proc/.test(url)) {
          prog.stage = 'process';
          prog.cap = 97;
          this.addEventListener('loadend', function () { prog.procDone = Date.now(); });
        }
        return send.apply(this, arguments);
      };
    })();

    /* Khách chọn ảnh khác khi modal đang mở (nút Replace photo trong modal):
       trả canvas về chỗ cũ rồi dựng lại modal ở trạng thái đang tải, vòng
       kiểm sẽ gắn canvas vào lại khi ảnh mới xong. */
    function resetToLoading() {
      closeModal();
      openModal();
    }

    function openModal() {
      if (document.documentElement.classList.contains(OPEN_CLASS)) return;
      if (isMobileLayout()) { openAppPreview(); return; }

      var layer = el('div', 'cl-edit-layer cl-edit-layer--loading');
      layer.setAttribute('role', 'dialog');
      layer.setAttribute('aria-modal', 'true');

      var head = el('div', 'cl-edit-head');
      head.appendChild(el('span', 'cl-edit-title', 'Adjust your photo'));

      /* Lối mở hướng dẫn ngay trong modal: đây là lúc khách thực sự cần đọc,
         chứ không phải lúc còn đang ở ô upload.
         Dùng lại đúng hộp thoại photo-guidelines-modal, không dựng bản sao —
         nội dung chỉ có một chỗ để sửa. <dialog>.showModal() vẽ ở lớp trên
         cùng của trình duyệt nên nó tự nằm trên modal này, khỏi lo z-index. */
      var guideDialog = document.getElementById('photo-guidelines-dialog');
      if (guideDialog) {
        var guideBtn = el('button', 'cl-edit-guide');
        guideBtn.type = 'button';
        guideBtn.innerHTML =
          '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true">' +
          '<circle cx="12" cy="12" r="9"></circle><path d="M12 11v5" stroke-linecap="round"></path>' +
          '<path d="M12 8h.01" stroke-linecap="round"></path></svg><span>Photo guidelines</span>';
        guideBtn.addEventListener('click', function () {
          if (guideDialog.showModal) guideDialog.showModal();
          else guideDialog.open = true;
        });
        head.appendChild(guideBtn);
      }

      var closeBtn = el('button', 'cl-edit-close');
      closeBtn.type = 'button';
      closeBtn.setAttribute('aria-label', 'Close');
      closeBtn.innerHTML = '&times;';
      closeBtn.addEventListener('click', closeModal);
      head.appendChild(closeBtn);

      var loading = buildLoading();

      var hint = el('p', 'cl-edit-hint',
        'Tip: you can also drag the photo directly in the preview to move it.');

      var foot = el('div', 'cl-edit-foot');

      /* Đổi ảnh ngay trong modal: bấm hộ nút Replace thật ở ô upload thay vì tự
         mở hộp chọn file. Ô file là của app, tự mở rồi gán file vào sẽ không
         chạy qua luồng xử lý của Customily. */
      var replaceBtn = el('button', 'cl-edit-replace', 'Replace photo');
      replaceBtn.type = 'button';
      replaceBtn.addEventListener('click', function () {
        var real = document.querySelector('#cl_optionsapp .customily-file-with-thumbnail .customily-download-button');
        if (real) real.click();
      });

      var doneBtn = el('button', 'cl-edit-done', 'Done');
      doneBtn.type = 'button';
      doneBtn.addEventListener('click', closeModal);

      foot.appendChild(replaceBtn);
      foot.appendChild(doneBtn);

      layer.addEventListener('click', function (e) {
        if (e.target === layer) closeModal();   // chỉ khi bấm trúng nền
      });

      /* Tất cả nằm trong MỘT thẻ trắng. Trước đây tiêu đề, dấu × và nút Done
         gắn thẳng vào lớp nền nên chúng trôi lơ lửng trên nền tối, chỉ mỗi
         canvas có khung — nhìn thành ba mảnh rời chứ không ra một hộp thoại. */
      var card = el('div', 'cl-edit-card');

      /* Bề ngang thẻ lấy đúng bằng ô ảnh sản phẩm.
         App đo khối chứa để quyết cỡ canvas rồi GIỮ NGUYÊN con số đó. Nếu thẻ
         hẹp hơn ô ảnh, canvas tính theo thẻ (560px) và khi trả về ô ảnh rộng
         734px thì ảnh xem trước bé hẳn so với ảnh mockup ban đầu. App không
         lắng nghe resize nên không có cách nào ép nó tính lại — chỉ còn cách
         cho hai bên bằng nhau ngay từ đầu. */
      var slide = document.querySelector('.customily_gallery_slide')
               || (canvasBox() && canvasBox().parentElement);
      if (slide) {
        var w = Math.round(slide.getBoundingClientRect().width);
        /* Bề ngang bằng đúng ô ảnh sản phẩm, KHÔNG hẹp hơn: app dựng bitmap
           canvas theo bề ngang khối chứa, hẹp đi là bitmap tụt theo và đóng
           modal xong ảnh ngoài bị mờ (đo được bitmap 540 hiển thị ở 734).
           Chiều cao xử bằng zoom ở hàm fitCanvas bên dưới. */
        if (w > 320) card.style.width = 'min(' + w + 'px, calc(100vw - 32px))';
      }
      card.appendChild(head);
      card.appendChild(loading);
      // Gợi ý đặt NGAY DƯỚI hàng nút nó đang nói tới, không phải trên đầu modal.
      card.appendChild(hint);
      card.appendChild(foot);
      layer.appendChild(card);

      document.body.appendChild(layer);
      document.documentElement.classList.add(OPEN_CLASS);
      document.body.style.overflow = 'hidden';
      try { closeBtn.focus({ preventScroll: true }); } catch (err) {}

      /* Chỉ gắn canvas khi ảnh đã tải XONG. Không kiểm điều kiện này thì hỏng:
         app dựng sẵn .cl-canvas-container ngay từ lúc tải trang (còn rỗng), nên
         mountCanvas() sẽ gắn khung rỗng vào và xoá mất khối đang tải — khách
         nhìn thấy một ô trắng thay vì biết hệ thống đang xử lý.
         Trường hợp bấm "Adjust photo" thì ảnh vốn đã xong, nhánh này chạy ngay. */
      var ready = uploadedSrc();
      // Vừa chọn ảnh khác thì app còn đang giữ ảnh CŨ ở trạng thái "xong" —
      // gắn lúc này là khách thấy ảnh cũ thay vì thanh tiến độ.
      if (ready && ready !== srcBeforeChange) mountCanvas();
    }

    /* Nút mở lại. Đóng modal xong thì canvas về chỗ cũ dưới ảnh sản phẩm, không
       còn lối nào quay lại khung chỉnh — nên gắn thêm một nút vào đúng hàng nút
       của ô upload, cạnh Replace.

       Vue của app vẽ lại vùng này mỗi khi trạng thái đổi và sẽ xoá mất nút, nên
       hàm này được gọi lại trong mỗi vòng kiểm. */
    function ensureReopenButton() {
      var row = document.querySelector('#cl_optionsapp .customily-file-with-thumbnail .cl-flex-no-wrap');
      if (!row || row.querySelector('.cl-edit-reopen')) return;
      var btn = el('button', 'cl-edit-reopen', 'Adjust photo');
      btn.type = 'button';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openModal();
      });
      row.appendChild(btn);
    }

    function check() {
      if (prog.stage !== 'fail' && document.querySelector('.cl-edit-loading')) {
        if (document.querySelector('#cl_optionsapp .spinner-border')) prog.sawBusy = true;
        else if (prog.sawBusy && uploadError()) { progFail(); return; }
      }
      var src = uploadedSrc();
      if (!src) {
        return;   // đang tải hoặc chưa có ảnh — modal (nếu mở) vẫn ở trạng thái loading
      }
      // Vẫn đang là ảnh cũ -> ảnh mới chưa xong, giữ nguyên trạng thái đang tải.
      if (srcBeforeChange && src === srcBeforeChange) return;
      srcBeforeChange = null;
      openedFor = src;
      ensureReopenButton();
      mountCanvas();
    }

    /* Mở modal ngay lúc chọn file, không chờ tải xong.
       Bắt bằng uỷ quyền ở document với capture: ô file của app do Vue dựng và
       vẽ lại nhiều lần, gắn thẳng listener lên nó là mất sau lần vẽ lại đầu. */
    /* Nút "Adjust photo" của CHÍNH APP (trong ô upload, cạnh "Replace").

       Có hai nút cùng tên: nút theme tự thêm (.cl-edit-reopen) đi qua openModal()
       nên được gắn cờ data-cl-edit-mode đầy đủ; còn nút của app thì tự mở modal
       của nó, không đụng gì tới code này. Thiếu cờ đó thì CSS ẩn hết hàng
       Move/Zoom/Rotate và hai nút dưới vẫn là "Keep editing / Add to cart" —
       khách bấm Adjust photo nhưng nhận được modal xem trước, không chỉnh được gì.

       Bắt ở document với capture và nhận diện theo NHÃN chứ không theo class:
       class của app đổi giữa các phiên bản, còn chữ "Adjust photo" là thứ khách
       nhìn thấy nên ổn định hơn. Không chặn sự kiện — cứ để app mở modal như
       thường, mình chỉ gắn cờ và đổi nút theo sau. */
    document.addEventListener('click', function (e) {
      if (!isMobileLayout()) return;
      var t = e.target && e.target.closest ? e.target.closest('#cl_optionsapp button, #cl_optionsapp [role="button"], #cl_optionsapp a') : null;
      if (!t || t.classList.contains('cl-edit-reopen')) return;
      if (!/adjust\s*photo/i.test(t.textContent || '')) return;
      setTimeout(openAppPreview, 0);
    }, true);

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.type !== 'file') return;
      if (!t.closest('#cl_optionsapp')) return;
      if (!t.files || !t.files.length) return;
      openedFor = null;
      /* Nhớ ảnh hiện tại để vòng kiểm biết đâu là ảnh CŨ. Không có mốc này thì
         ngay sau khi reset, vòng kiểm thấy ảnh cũ vẫn ở trạng thái "đã xong" và
         gắn lại nó vào modal — trạng thái đang tải biến mất trong tích tắc. */
      srcBeforeChange = uploadedSrc();
      mobileUploading = isMobileLayout();
      if (document.documentElement.classList.contains(OPEN_CLASS)) resetToLoading();
      else openModal();
      progStart();
    }, true);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.documentElement.classList.contains(OPEN_CLASS)) {
        e.preventDefault();
        closeModal();
      }
    });

    function start() {
      check();
      new MutationObserver(check).observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
